import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Permission } from '../common/enums/permissions';
import { AuthGuard } from '../core/authentication/auth.guard';
import { PermissionGuard } from '../core/authentication/permission.guard';
import { AddOrderFormComponent } from './add-order-form/add-order-form/add-order-form.component';
import { OrdersTabsContainerComponent } from './orders-tabs-container/orders-tabs-container.component';
import { HasPermissionToModuleGuard, ModuleName } from '../subscription-package';
import { OrdersListComponent } from './orders/orders-list/orders-list.component';
import { OrdersStartRealizationListComponent } from './orders-start-realization-list/orders-start-realization-list.component';
import { OrdersRealizationListComponent } from './orders-realization-list/orders-realization-list.component';

const routes: Routes = [
  {
    path: 'orders',
    component: OrdersTabsContainerComponent,
    canActivate: [AuthGuard, PermissionGuard, HasPermissionToModuleGuard],
    data: {
      permissions: [Permission.ManageEmployeesOrder],
      moduleName: ModuleName.Orders
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        component: OrdersListComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: [Permission.ManageEmployeesOrder],
        },
      },
      {
        path: 'start-realization-list',
        component: OrdersStartRealizationListComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: [Permission.ManageOrderStartRealization],
        },
      },
      {
        path: 'realization-list',
        component: OrdersRealizationListComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: [Permission.ManageOrderRealization],
        },
      },
    ]
  },
  {
    path: 'addOrders',
    component: AddOrderFormComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: { permissions: [Permission.CreateOrder] },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersRoutingModule {}
